module.exports = __webpack_public_path__ + "media/images/front/varieties/ORONULES-b786edd8d4c756f204fd821936c29c5a.jpg";